module.exports = __webpack_public_path__ + "img/blll.153a445a.png";